import React from 'react';
import DownloadCatalogues from '../components/DownloadCatalogues';




export default function DownloadCataloguesPage() {
  return (
    // Use a <main> tag or a Fragment <> to group the components
    <main>
     
     {/* <ContactForm />
     <GlobalPresence /> */}
     <DownloadCatalogues />
    </main>
  );
}